__turbopack_context__.v({
  "gallery": "ArticleModuleGallery-module-scss-module__6DEqHG__gallery",
  "wrapper": "ArticleModuleGallery-module-scss-module__6DEqHG__wrapper",
});
